import { ArrayFieldTemplateProps } from '@rjsf/core'
import {
  IconButton,
  Typography,
  createStyles,
  makeStyles,
  Theme,
  Paper,
} from '@material-ui/core'
import { LocalizedButton } from 'components/Localization/LocalizedButton'
import { ClearOutlined } from '@material-ui/icons'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    addButton: {
      backgroundColor: theme.palette.background.paper,
      position: 'sticky',
      top: '2.3em',
      zIndex: 2,
      padding: theme.spacing(2),
      borderBottom: `2px solid ${theme.palette.divider}`,
      width: '100%',
    },
  })
)

export function ArrayFieldTemplate(props: ArrayFieldTemplateProps) {
  const cn = useStyles()

  return (
    <>
      <div className={cn.addButton}>
        <LocalizedButton
          variant="outlined"
          translationKey="project:working-steps-add-details"
          onClick={props.onAddClick}
        />
      </div>

      <div className={`${props.className} array-field-root`}>
        <div className="array-items-root">
          {props.items &&
            props.items.map((element, index) => (
              <Paper
                key={element.key}
                className={`${element.className}`}
                elevation={0}
              >
                <div className="element-root">
                  <div className="row-num">
                    <Typography variant="caption" noWrap>
                      {index + 1}.
                    </Typography>
                  </div>
                  <div className="array-field-children">{element.children}</div>
                  <div className="delete-item">
                    <IconButton
                      className="delete-button"
                      onClick={element.onDropIndexClick(element.index)}
                      color="secondary"
                    >
                      <ClearOutlined />
                    </IconButton>
                  </div>
                </div>
              </Paper>
            ))}
        </div>
      </div>
    </>
  )
}
